import ModalReminders from './modalReminders';

export default ModalReminders;
